export default function tabs() {
    const clear = function clearTabs() {
        const menuElements = document.querySelectorAll('[data-tab]');
        menuElements.forEach((element) => {
            element.classList.remove('active');
            const dataTab = element.getAttribute('data-tab');
            const tabElement = document.querySelector(`.${dataTab.toLowerCase()}`);
            tabElement.classList.remove('active');
        });
    };

    const change = function changeTabs(event) {
        clear();
        event.target.classList.add('active');
        const dataTab = event.currentTarget.getAttribute('data-tab');
        const tabElement = document.querySelector(`.${dataTab.toLowerCase()}`);
        tabElement.classList.add('active');
    };

    const bindAll = function bindAllTabs() {
        const menuElements = document.querySelectorAll('[data-tab]');
        menuElements.forEach((element) => {
            element.addEventListener('click', change, false);
        });
    };

    const changeMobileTab = function changeMobileTab() {
        const selectedOption = document.querySelector('.select-items .selected');
        document.querySelectorAll('.tab-content').forEach((element) => {
            const tabToHide = element;
            tabToHide.style.display = 'none';
        });
        const showTab = document.querySelector(`.${selectedOption.innerHTML.toLowerCase()}`);
        showTab.style.display = 'block';
    };

    const mobileSelectField = document.querySelector('.section-tab-select-js');
    bindAll();

    if (!mobileSelectField) {
        return;
    }
    mobileSelectField.addEventListener('click', changeMobileTab, false);
}
window.addEventListener('load', tabs);
